import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@services/settings.service';
import { firstValueFrom } from 'rxjs';

export const ROUTES_FEATURE_FLAGS_MAP_SUBJECT = 'routes';
export const ROUTES_FEATURE_FLAGS_MAP_ATTRIBUTE = 'feature-flags-map';

export type RoutesFeatureFlagsMap = Record<string, string>;

@Injectable({ providedIn: 'root' })
export class RoutesFeatureFlagsMapService {
  private readonly settingsService = inject(SettingsService);

  private result$: Promise<RoutesFeatureFlagsMap> | null = null;

  async getFeatureFlagKey(routeUrl: string): Promise<string> {
    const map = await this.load();
    return map[routeUrl] ?? '';
  }

  load(): Promise<RoutesFeatureFlagsMap> {
    this.result$ ??= this.fetchMap().catch(err => {
      this.result$ = null;
      console.error('Failed to load the routes feature flags map', err);
      throw err;
    });
    return this.result$;
  }

  private async fetchMap(): Promise<RoutesFeatureFlagsMap> {
    const map = await firstValueFrom(
      this.settingsService.get<RoutesFeatureFlagsMap>(ROUTES_FEATURE_FLAGS_MAP_SUBJECT, ROUTES_FEATURE_FLAGS_MAP_ATTRIBUTE, true),
    );

    if (map === undefined) throw new Error('The routes feature flags map setting could not be read');

    return map;
  }
}
